import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";

// STATE AND STORE
// LIBS
import { loggedIn, login } from "../../api/jwt";
import { setUser } from "../../actions/MyUserActions";
import Model from "../../models/login";
import validateForm from "../../lib/helpers/validateForm";

// STYLE
import "../../css/login.css";
// UI
import { Alerts, Input, Container, Button, Header, Box } from "../../ui";
// import {Input, Container, Button, Header, Box, Row, Col} from '../../ui';
import LogoLeo from "../../components/logo/icon";
import LogoLabel from "../../components/logo/label";

class LoginPage extends Component {
  state = {
    titleHeader: "Вход в систему",
    form: {
      username: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.username
      },
      password: {
        value: "",
        isEdited: false,
        isError: false,
        errors: [],
        validate: Model.password
      }
    },
    buttons: {
      save: {
        disabled: false,
        title: "Войти"
      }
    }
  };

  componentWillMount() {
    if (loggedIn()) {
      this.props.history.replace("/dashboard");
    }
  }

  componentDidMount() {
    // const {dispatch} = this.props
  }

  handleInput = e => {
    let value = e.target.value;
    let name = e.target.name;
    const { form } = this.state;

    if (name && form[name]) {
      if (form[name].isNumber) {
        value = String(value) || "";
      }

      this.setState(prevState => {
        return {
          form: {
            ...prevState.form,
            [name]: {
              ...prevState.form[name],
              value,
              isEdited: true,
              isError: false,
              errors: []
            }
          }
        };
      });
    }
  };

  handleFormSubmit = async e => {
    e.preventDefault();

    const result = validateForm(this.state.form);

    this.setState({
      form: result.form
    });

    // Success
    if (result.valid) {
      const { save } = this.state.buttons;
      save.disabled = true;

      // Отключаем кнопку
      this.setState(prevState => {
        return {
          buttons: { ...prevState.buttons, save },
          loading: true
        };
      });

      save.disabled = false;

      const { form } = this.state;
      const optionsRequest = {};

      for (let nameItem in form) {
        if (form[nameItem].isEdited) {
          optionsRequest[nameItem] = form[nameItem].value;
        }
      }

      // Есть изменения?
      if (Object.keys(optionsRequest).length === 2) {
        // Вход и получение пользователя
        try {
          const user = await login({ ...optionsRequest });

          if (user) {
            // Сохраняем пользователя
            const { dispatch } = this.props;

            dispatch(setUser(user));

            // Включаем кнопку, данные сохранились
            this.props.history.replace("/dashboard");
          } else {
            Alerts.error("Неправильные Имя пользователя/Пароль");

            // Включаем кнопку, данные не сохранились
            this.setState(prevState => {
              return {
                buttons: { ...prevState.buttons, save }
              };
            });
          }
        } catch (err) {
          console.log(err);

          Alerts.error("Неправильные Имя пользователя/Пароль");

          // Включаем кнопку, данные не сохранились
          this.setState(prevState => {
            return {
              buttons: { ...prevState.buttons, save }
            };
          });
        }
      } else {
        Alerts.alert("Заполните все поля");

        // Включаем кнопку, данные не сохранились
        this.setState(prevState => {
          return {
            buttons: { ...prevState.buttons, save }
          };
        });
      }
    }
  };

  render() {
    return (
      <div className="short login-page">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <Container className="login">
          <div className="logo logo-container">
            <LogoLeo />
            <LogoLabel />
          </div>

          <Box>
            <Header size={4} className="login-title" margin="no-top">
              {this.state.titleHeader}
            </Header>

            <form className="form" onSubmit={this.handleFormSubmit}>
              <Input
                label="Имя пользователя"
                labelClassName="semibold"
                name="username"
                size="l"
                value={this.state.form.username.value}
                errors={this.state.form.username.errors}
                handleChange={this.handleInput}
              />

              {/* <Row withMain={true}>
                <Col normal={true} padding="no"><label for="password">Пароль:</label></Col>
                <Col main={true} padding="no" text="right"><label>Забыли пароль?</label></Col>
              </Row> */}

              <Input
                label="Пароль"
                labelClassName="semibold"
                name="password"
                type="password"
                size="l"
                value={this.state.form.password.value}
                errors={this.state.form.password.errors}
                handleChange={this.handleInput}
              />
              <Button
                type="submit"
                theme="primary"
                block={true}
                size="l"
                disabled={this.state.buttons.save.disabled}
              >
                {this.state.buttons.save.title}
              </Button>
            </form>
          </Box>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(LoginPage);
